import { dateFormatter } from 'core/helpers/formatters';
import { getIncidentTypeLabel } from 'customer/components/policy/incidents/helpers';

export const describeIncident = (incident) =>
  [dateFormatter(incident.date), `Violation (${getIncidentTypeLabel(incident.type)})`, incident.driver]
    .filter(Boolean)
    .join(' — ');

// "Select At-Fault on 03/04/2025 for Alex Rivera", the accessible name of a row's checkbox or action
export const actionLabel = (verb, incident) =>
  `${verb} ${getIncidentTypeLabel(incident.type)} on ${dateFormatter(incident.date)}${
    incident.driver ? ` for ${incident.driver}` : ''
  }`;

export const checkboxLabel = (incident) => actionLabel('Select', incident);

export const countLabel = (count, singular, plural) => (count === 1 ? singular : plural.replace('{n}', count));
